import React, {useState} from 'react';
import {amountFormatter} from '@utils/helpers';
import {HiMinus, HiPlus} from "react-icons/hi";
import ProductPreview from "@components/Menu/ProductPreview";

const Product = ({product, selectedQty, selectedProducts, setSelectedProducts, viewMode}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {id, name, description, imagePath, price} = product;

  const addProduct = (product) => {
    setSelectedProducts((prev) => {
      const foundProduct = selectedProducts.find(({id}) => id === product.id);

      if (foundProduct) {
        return prev.map((p) => (p.id === product.id ? {...p, qty: p.qty + 1} : p));
      }

      return [...prev, {...product, qty: 1}];
    });
  };

  const removeProduct = (productId) => {
    setSelectedProducts((prev) => {
      const foundProduct = selectedProducts.find(({id}) => id === productId);

      if (foundProduct) {
        if (foundProduct.qty > 1) {
          return prev.map((p) => (p.id === productId ? {...p, qty: p.qty - 1} : p));
        }
        return prev.filter((p) => p.id !== productId);
      }

      return prev;
    });
  };

  return (
    <div
      key={id}
      className="relative flex my-3 items-center py-3 shadow-sm border-b border-gray-300 border-dashed hover:border-gray-900 transition duration-300"
    >
      {selectedQty > 0 && (
        <div
          className="absolute top-1 -left-1 border-2 border-white rounded-full px-2 bg-gradient-to-r from-cyan-600 from-10% via-sky-900 via-30% to-blue-900 to-90% text-white text-sm"
        >
          {selectedQty}
        </div>
      )}
      <img src={imagePath} alt={name} className="w-28 rounded-md cursor-pointer"
           onClick={() => setIsOpen(!isOpen)}/>
      <div className='flex flex-col ml-5 w-full'>
        <div className="flex-1">
          <div className="text-sm font-[600]">{name}</div>
          <div className="text-xs my-0.5 mr-2" style={{
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}>{description}</div>
        </div>
        <div className="flex items-center justify-between mt-3">
          <div className="text-gray-900 font-[600]">{amountFormatter(price, 'ALL')}</div>
          {!viewMode && <div className='flex'>
            <div
              onClick={() => removeProduct(id)}
              className="p-1 bg-gray-200 text-gray-900 rounded-full mx-3 active:opacity-70 active:text-opacity-70 cursor-pointer transition duration-300"
            >
              <HiMinus size={16}/>
            </div>
            <div className="text font-semibold">{selectedQty}</div>
            <div
              onClick={() => addProduct(product)}
              className="p-1 bg-gray-200 text-gray-900 rounded-full mx-3 active:opacity-70 active:text-opacity-70 cursor-pointer"
            >
              <HiPlus size={16}/>
            </div>
          </div>}
        </div>
      </div>
      <ProductPreview product={product} selectedQty={selectedQty} onProductRemove={removeProduct}
                      onProductAdd={addProduct} isOpen={isOpen} setIsOpen={setIsOpen} viewMode={viewMode}/>
    </div>
  );
};

const CategoryProductList = ({
                               category,
                               selectedProducts,
                               setSelectedProducts,
                               categoryRefs,
                               inLastCategory,
                               viewMode
                             }) => {
  return (
    <div className='mb-3' key={category.id} ref={(ref) => (categoryRefs[category.id] = ref)}>
      <div className="text-lg font-[600]">{category?.name}</div>
      {category?.magProducts?.map((product) => {
        const selectedQty = selectedProducts.find((p) => p.id === product.id)?.qty || 0;

        return (
          <Product viewMode={viewMode} key={product.id} product={product} selectedQty={selectedQty}
                   selectedProducts={selectedProducts}
                   setSelectedProducts={setSelectedProducts}/>
        );
      })}
      {inLastCategory && <div className='w-full h-12 relative flex my-3 items-center py-3'/>}
    </div>
  );
};

export default CategoryProductList;